export default __webpack_public_path__ + "static/media/sfs_logo_full.c49b4909.png";